import { render, staticRenderFns } from "./circle-editor.vue?vue&type=template&id=46cbc20e&scoped=true&"
import script from "./circle-editor.vue?vue&type=script&lang=js&"
export * from "./circle-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cbc20e",
  null
  
)

export default component.exports